import EditIcon from "@mui/icons-material/Edit";
import { Grid2 as Grid, IconButton } from "@mui/material";
import { IHeaderParams } from "ag-grid-community";

interface CustomHeaderProps extends IHeaderParams {
	editCallback: (colId: string) => void;
}

export const CustomHeader = (props: CustomHeaderProps) => {
	const { displayName, editCallback, column } = props;

	return (
		<Grid container alignItems="center" spacing={0}>
			<Grid size={{ xs: 8 }}>
				<span>{displayName}</span>
			</Grid>
			<Grid size={{ xs: 4 }}>
				<IconButton
					color="primary"
					onClick={() => editCallback(column.getColId())}
					title={`Edit ${displayName}`}
					size="medium"
				>
					<EditIcon style={{ cursor: "pointer" }} fontSize="small" />
				</IconButton>
			</Grid>
		</Grid>
	);
};
